export default __webpack_public_path__ + "static/media/twitter-icon.cca67609.png";